import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box, Drawer, List, ListItemIcon, ListItemButton, ListItemText, CssBaseline } from '@mui/material';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { Link } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';

const drawerWidth = 290;
const appBarHeight = 64; // Default MUI AppBar height

const MainLayout: React.FC = () => {
  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', flexDirection: 'column' }}>
      <CssBaseline />
      <Header />
      <Box sx={{ display: 'flex', flex: 1, pt: `${appBarHeight}px` }}>
        <Drawer
          variant="permanent"
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            [`& .MuiDrawer-paper`]: {
              width: drawerWidth,
              boxSizing: 'border-box',
              bgcolor: 'background.paper',
              marginTop: `${appBarHeight}px`,
              height: `calc(100vh - ${appBarHeight}px)`,
              display: 'flex',
              flexDirection: 'column',
            },
          }}
        >
          {/** Sidebar Navigation Links. TODO: All icons needs to be refactored to fitting icons */}
          <List sx={{ p: 0 }}>
            <ListItemButton
              component={Link}
              to="/home"
                  sx={{
                  p: 0,
                  flex: 1,
                  overflowY: 'auto',
                  minHeight: 0,
                  pb: 2, // padding at the bottom for last item visibility when using small screens
                }}
            >
              <ListItemIcon sx={{ minWidth: 32, mr: 1 }}> {/* Reduce icon width and add margin */}
                <HomeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="Home"
                sx={{ m: 0 }} // Remove extra margin
              />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/adSpaces"
              sx={{ py: 1, px: 2, minHeight: 36, m: 0, pt: 0, pb: 0 }} 
            >
              <ListItemIcon sx={{ minWidth: 32, mr: 1 }}> {/* Reduce icon width and add margin */}
                <HomeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="AdSpaces"
                sx={{ m: 0 }} 
              />
            </ListItemButton>  

            <ListItemButton
              component={Link}
              to="/activeAdSpaces"
              sx={{ py: 1, px: 2, minHeight: 36, m: 0, pt: 0, pb: 0 }} 
            >
              <ListItemIcon sx={{ minWidth: 32, mr: 1 }}> {/* Reduce icon width and add margin */}
                <HomeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="ActiveAdSpaces"
                sx={{ m: 0 }} 
              />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/adSpacePhotos"
              sx={{ py: 1, px: 2, minHeight: 36, m: 0, pt: 0, pb: 0 }} 
            >
              <ListItemIcon sx={{ minWidth: 32, mr: 1 }}> {/* Reduce icon width and add margin */}
                <HomeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="AdSpacePhotos"
                sx={{ m: 0 }} 
              />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/adSpacePhotoComments"
              sx={{ py: 1, px: 2, minHeight: 36, m: 0, pt: 0, pb: 0 }} 
            >
              <ListItemIcon sx={{ minWidth: 32, mr: 1 }}> {/* Reduce icon width and add margin */}
                <HomeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="AdSpacePhotoComments"
                sx={{ m: 0 }} 
              />
            </ListItemButton>            

            <ListItemButton
              component={Link}
              to="/apiTokens"
              sx={{ py: 1, px: 2, minHeight: 36, m: 0, pt: 0, pb: 0 }} 
            >
              <ListItemIcon sx={{ minWidth: 32, mr: 1 }}> {/* Reduce icon width and add margin */}
                <HomeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="ApiTokens"
                sx={{ m: 0 }} 
              />
            </ListItemButton>    

            <ListItemButton
              component={Link}
              to="/supportDashboard"
              sx={{ py: 1, px: 2, minHeight: 36, m: 0, pt: 0, pb: 0 }} 
            >
              <ListItemIcon sx={{ minWidth: 32, mr: 1 }}> {/* Reduce icon width and add margin */}
                <HomeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="Support Dashboard"
                sx={{ m: 0 }} 
              />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/adSpaceOwnerPackages"
              sx={{ py: 1, px: 2, minHeight: 36, m: 0, pt: 0, pb: 0 }} 
            >
              <ListItemIcon sx={{ minWidth: 32, mr: 1 }}> {/* Reduce icon width and add margin */}
                <HomeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="OwnerPackages"
                sx={{ m: 0 }} 
              />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/currencies"
              sx={{ py: 1, px: 2, minHeight: 36, m: 0, pt: 0, pb: 0 }} 
            >
              <ListItemIcon sx={{ minWidth: 32, mr: 1 }}> {/* Reduce icon width and add margin */}
                <HomeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="Currencies"
                sx={{ m: 0 }} 
              />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/adSpaceCouponCodes"
              sx={{ py: 1, px: 2, minHeight: 36, m: 0, pt: 0, pb: 0 }} 
            >
              <ListItemIcon sx={{ minWidth: 32, mr: 1 }}>
                <HomeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="AdSpace Coupon Codes"
                sx={{ m: 0 }} 
              />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/couponCodes"
              sx={{ py: 1, px: 2, minHeight: 36, m: 0, pt: 0, pb: 0 }} 
            >
              <ListItemIcon sx={{ minWidth: 32, mr: 1 }}>
                <HomeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="Global Coupon Codes"
                sx={{ m: 0 }} 
              />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/emailEvents"
              sx={{ py: 1, px: 2, minHeight: 36, m: 0, pt: 0, pb: 0 }} 
            >
              <ListItemIcon sx={{ minWidth: 32, mr: 1 }}>
                <HomeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="Email Events"
                sx={{ m: 0 }} 
              />
            </ListItemButton>              

            <ListItemButton
              component={Link}
              to="/paymentDetails"
              sx={{ py: 1, px: 2, minHeight: 36, m: 0, pt: 0, pb: 0 }} 
            >
              <ListItemIcon sx={{ minWidth: 32, mr: 1 }}>
                <HomeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="Payment Details"
                sx={{ m: 0 }} 
              />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/refundRequests"
              sx={{ py: 1, px: 2, minHeight: 36, m: 0, pt: 0, pb: 0 }} 
            >
              <ListItemIcon sx={{ minWidth: 32, mr: 1 }}>
                <HomeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="Refund Requests"
                sx={{ m: 0 }} 
              />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/payouts"
              sx={{ py: 1, px: 2, minHeight: 36, m: 0, pt: 0, pb: 0 }} 
            >
              <ListItemIcon sx={{ minWidth: 32, mr: 1 }}>
                <HomeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="Payouts Management"
                sx={{ m: 0 }} 
              />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/purchasePlans"
              sx={{ py: 1, px: 2, minHeight: 36, m: 0, pt: 0, pb: 0 }} 
            >
              <ListItemIcon sx={{ minWidth: 32, mr: 1 }}> {/* Reduce icon width and add margin */}
                <HomeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="PurchasePlans"
                sx={{ m: 0 }} 
              />
            </ListItemButton>          

            <ListItemButton
              component={Link}
              to="/mediaTypes"
              sx={{ py: 1, px: 2, minHeight: 36, m: 0, pt: 0, pb: 0 }} 
            >
              <ListItemIcon sx={{ minWidth: 32, mr: 1 }}> {/* Reduce icon width and add margin */}
                <HomeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="MediaTypes"
                sx={{ m: 0 }} 
              />
            </ListItemButton>              

             <ListItemButton
              component={Link}
              to="/sizeDataTypes"
              sx={{ py: 1, px: 2, minHeight: 36, m: 0, pt: 0, pb: 0 }} 
            >
              <ListItemIcon sx={{ minWidth: 32, mr: 1 }}> {/* Reduce icon width and add margin */}
                <HomeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="SizeDataTypes"
                sx={{ m: 0 }} 
              />
            </ListItemButton>

            
             <ListItemButton
              component={Link}
              to="/subscriptionPlans"
              sx={{ py: 1, px: 2, minHeight: 36, m: 0, pt: 0, pb: 0 }} 
            >
              <ListItemIcon sx={{ minWidth: 32, mr: 1 }}> {/* Reduce icon width and add margin */}
                <HomeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="SubscriptionPlans"
                sx={{ m: 0 }} 
              />
            </ListItemButton>   

             <ListItemButton
              component={Link}
              to="/systemNotifications"
              sx={{ py: 1, px: 2, minHeight: 36, m: 0, pt: 0, pb: 0 }} 
            >
              <ListItemIcon sx={{ minWidth: 32, mr: 1 }}> {/* Reduce icon width and add margin */}
                <HomeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="SystemNotifications"
                sx={{ m: 0 }} 
              />
            </ListItemButton>              

            <ListItemButton
              component={Link}
              to="/tokenPlans"
              sx={{ py: 1, px: 2, minHeight: 36, m: 0, pt: 0, pb: 0 }} 
            >
              <ListItemIcon sx={{ minWidth: 32, mr: 1 }}> {/* Reduce icon width and add margin */}
                <HomeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="TokenPlans"
                sx={{ m: 0 }} 
              />
            </ListItemButton>                   

            <ListItemButton
              component={Link}
              to="/users"
              sx={{ py: 1, px: 2, minHeight: 36, m: 0, pt: 0, pb: 0 }} 
            >
              <ListItemIcon sx={{ minWidth: 32, mr: 1 }}> {/* Reduce icon width and add margin */}
                <HomeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="Users"
                sx={{ m: 0 }} 
              />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/userSessions"
              sx={{ py: 1, px: 2, minHeight: 36, m: 0, pt: 0, pb: 0 }} 
            >
              <ListItemIcon sx={{ minWidth: 32, mr: 1 }}> {/* Reduce icon width and add margin */}
                <HomeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="UserSessions"
                sx={{ m: 0 }} 
              />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/userRoles"
              sx={{ py: 1, px: 2, minHeight: 36, m: 0, pt: 0, pb: 0 }} 
            >
              <ListItemIcon sx={{ minWidth: 32, mr: 1 }}> {/* Reduce icon width and add margin */}
                <HomeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="UserRoles"
                sx={{ m: 0 }} 
              />
            </ListItemButton>  

            <ListItemButton
              component={Link}
              to="/usersPurchasePlans"
              sx={{ py: 1, px: 2, minHeight: 36, m: 0, pt: 0, pb: 0 }} 
            >
              <ListItemIcon sx={{ minWidth: 32, mr: 1 }}> {/* Reduce icon width and add margin */}
                <HomeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="UsersPurchasePlans"
                sx={{ m: 0 }} 
              />
            </ListItemButton> 

            <ListItemButton
              component={Link}
              to="/usersSubscriptionPlans"
              sx={{ py: 1, px: 2, minHeight: 36, m: 0, pt: 0, pb: 0 }} 
            >
              <ListItemIcon sx={{ minWidth: 32, mr: 1 }}> {/* Reduce icon width and add margin */}
                <HomeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="UsersSubscriptionPlans"
                sx={{ m: 0 }} 
              />
            </ListItemButton>

            <ListItemButton
              component={Link}
              to="/usersTokenPlansTokens"
              sx={{ py: 1, px: 2, minHeight: 36, m: 0, pt: 0, pb: 0 }} 
            >
              <ListItemIcon sx={{ minWidth: 32, mr: 1 }}> {/* Reduce icon width and add margin */}
                <HomeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText
                primary="UsersTokenPlansTokens"
                sx={{ m: 0 }} 
              />
            </ListItemButton>            

            {/* Add more menu items here */}
          </List>
          
        </Drawer>
        <Box component="main" sx={{ flex: 1, p: 3 }}>
          <Outlet />
        </Box>
      </Box>
      <Footer />
    </Box>
  );
};

export default MainLayout;
